export default __webpack_public_path__ + "static/media/balcony.6c59426e.png";